import React from "react";
import StaffWorkingSchedule from "../../../pages/Staff/details/WorkingSchedule";

// Change #100163 (revised) - "it's in totally the wrong place. It needs to be a
// step of its own and look much better; right now it feels like it's slapped in
// right at the end."
//
// Its own step of the Create New User wizard (Step 6), after the user has been
// created on the Summary - a schedule belongs to this company's Staff record,
// which only exists once the user does, so it cannot come any earlier. The
// Summary keeps the new login details and sends you here with a "Next" button;
// this step can also be skipped, and changed later on the person's profile.
const initials = (first, last) =>
  `${(first || "").trim().charAt(0)}${(last || "").trim().charAt(0)}`.toUpperCase() || "?";

const TabWorkingSchedule = ({ createdUser, setActiveVerticalTab, setModal }) => {
  if (!createdUser?.Staff_Id) {
    return (
      <div className="text-center py-5">
        <i className="ri-calendar-schedule-line fs-1 text-muted d-block mb-2"></i>
        <h5 className="mb-1">Create the user first</h5>
        <p className="text-muted mb-3">
          The working schedule is set once the user exists - finish the Summary
          step, then come back here.
        </p>
        <button
          type="button"
          className="btn btn-soft-primary"
          onClick={() => setActiveVerticalTab(5)}
        >
          <i className="ri-arrow-left-line me-1"></i>Go to Summary
        </button>
      </div>
    );
  }

  const first = createdUser?.FirstName || createdUser?.UserFirstName || "";
  const last = createdUser?.LastName || createdUser?.UserLastName || "";
  const name = `${first} ${last}`.trim() || createdUser?.Email || "this person";

  return (
    <div>
      {/* Header: who this is for, and what the step does. */}
      <div
        className="d-flex align-items-center gap-3 p-3 mb-3 rounded-3"
        style={{
          background: "linear-gradient(120deg, rgba(79,70,229,0.10), rgba(109,40,217,0.06))",
          border: "1px solid rgba(79,70,229,0.18)",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-circle fw-bold text-white flex-shrink-0"
          style={{
            width: 48,
            height: 48,
            fontSize: 17,
            background: "linear-gradient(135deg, #4f46e5, #6d28d9)",
          }}
        >
          {initials(first, last)}
        </div>
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h4 className="mb-0">Working schedule</h4>
            <span className="badge bg-success-subtle text-success">
              <i className="ri-checkbox-circle-fill me-1"></i>User created
            </span>
          </div>
          <div className="text-muted">
            The hours <strong>{name}</strong> works for this company. It drives
            their availability on the diary and dispatch board.
          </div>
        </div>
      </div>

      <div className="alert alert-light border small d-flex gap-2 mb-3">
        <i className="ri-information-line text-primary fs-5 lh-1"></i>
        <span>
          Optional. Pick a schedule and the date it starts - you can skip this and
          set it later from their staff profile.
        </span>
      </div>

      {/* The same editor the staff profile uses, given room to breathe. */}
      <div className="card border shadow-none mb-3">
        <div className="card-body">
          <StaffWorkingSchedule staffId={String(createdUser.Staff_Id)} />
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
        <button
          type="button"
          className="btn btn-light"
          onClick={() => setActiveVerticalTab(5)}
        >
          <i className="ri-arrow-left-line me-1"></i>Back to summary
        </button>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-soft-secondary"
            onClick={() => setModal(false)}
          >
            Skip for now
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => setModal(false)}
          >
            <i className="ri-check-line me-1"></i>Finish
          </button>
        </div>
      </div>
    </div>
  );
};

export default TabWorkingSchedule;
